import React from 'react';
import { useRecoilValue } from 'recoil';
import { UserState } from '../../../../../utils/recoil/user';
import { NativeSelect } from '../NativeSelect/nativeSelect';

export const CountrySelect = (props) => {
  const user = useRecoilValue(UserState);
  return (
    <NativeSelect
      native
      {...props}
      values={user?.availableShoppingCountries?.map(({ name }) => ({
        label: { text: name },
        value: name,
      }))}
    />
  );
};
